import type { IconDefinition } from '../index.tsx';

export const iconChevronLeft: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconChevronLeft',
  icon: [
    16,
    16,
    [],
    '',
    'M7.82849 8.00015L12.4143 3.41436L9.58584 0.585938L2.17163 8.00015L9.58584 15.4144L12.4143 12.5859L7.82849 8.00015Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
